<script setup>
import * as Sentry from '@sentry/browser'
import { useRouter } from 'vue-router'
import { captureApiException } from '@/utility/sentry'

const router = useRouter()

function showMsg (error) {
    let msg
    if (error.data) {
        for (var message of Object.values(error.data)) {
            msg = message[0]
            console.error(msg)
        }
    } else if (error.message) {
        msg = error.message
        if (error.message.includes('Unauthorize')) {
            router.push('/login')
        }
        console.error('Error Message:' + msg)
    } else {
        msg = error
    }
    if (import.meta.env.VITE_BITRIXAPI === import.meta.env.VITE_BITRIXAPI + '' || import.meta.env.VITE_BITRIXAPI === 'https://bitrixapimaster.haandvaerker.dk/v1/') {
        Sentry.addBreadcrumb({
            category: 'auth',
            message: 'Authenticated user' + localStorage.getItem('CompanyName'),
            level: 'info'
        })
        Sentry.captureMessage(msg)
        captureApiException(msg)
    }
}

defineExpose({ showMsg })
</script>

<template>
    <div></div>
</template>